/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS,
  PENDING_INVOICES,
  PROFILE_INFO,
  SUPPLIER_INFO} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  pendingInvoices: [],
  profileData: [],
  supplierInfo: ''
};


/* eslint-disable default-case, no-param-reassign */
const gatr2aPendinInvoicesReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PENDING_INVOICES:
        return {
          ...state,
          pendingInvoices:action.pendingInvoices
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SUPPLIER_INFO:
        return {
          ...state,
          supplierInfo:action.supplierInfo
        }
      default:
        return state;
    }
  };

export default gatr2aPendinInvoicesReducer;
